import { useLocation, useSearchParams } from 'react-router-dom';
import { useEffect } from 'react';
import { usePostHog } from 'posthog-js/react';
import { redactSensitiveParams } from './posthog-provider';

export default function PostHogPageView() {
	const { hash, pathname } = useLocation();
	let [searchParams] = useSearchParams();
	const posthog = usePostHog();

	// Track pageviews
	useEffect(() => {
		try {
			if (hash && posthog) {
				// hash is a string like "#__posthog=..." — parse it as params
				const toolbarJSON = new URLSearchParams(hash.substring(1)).get('__posthog');

				if (toolbarJSON) {
					posthog.loadToolbar(JSON.parse(toolbarJSON));
				}
			}
		} catch (error) {
			console.error('Error loading PostHog toolbar', error.message);
		}

		try {
			if (pathname && posthog) {
				let url = window.origin + pathname;
				if (searchParams.toString()) {
					// strip token/PII params before the URL leaves the browser
					url = url + `?${redactSensitiveParams(searchParams.toString())}`;
				}
				posthog.capture('$pageview', {
					$current_url: url,
				});
			}
		} catch (error) {
			console.error('Error tracking pageview', error.message);
		}
	}, [pathname, searchParams, posthog]);

	return null;
}
